/* =====================================================================
   Tawilbeauty Reviews — filter, sort, pagination, modal form,
   product picker, custom file upload, votes, media lightbox.
   ===================================================================== */
(function () {
  'use strict';

  if (window.__vlReviewsInit) return;
  window.__vlReviewsInit = true;

  const MAX_FILES = 5;
  const MAX_FILE_MB = 20;

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function $(sel, root) { return (root || document).querySelector(sel); }

  function getVotedMap() {
    try { return JSON.parse(localStorage.getItem('vlReviewVotes') || '{}'); }
    catch (e) { return {}; }
  }
  function setVoteState(reviewId, state) {
    // state: 'up' | 'down' | null (null removes the vote entirely)
    const map = getVotedMap();
    if (state) map[reviewId] = state;
    else delete map[reviewId];
    try { localStorage.setItem('vlReviewVotes', JSON.stringify(map)); } catch (e) {}
  }
  function getVoteState(map, reviewId) {
    const v = map[reviewId];
    if (!v) return null;
    if (typeof v === 'string') return v;
    // legacy object format: if both true, take latest; otherwise take whichever is true
    if (v.up && !v.down) return 'up';
    if (v.down && !v.up) return 'down';
    return null;
  }

  /* Reviews this browser owns (id → { token, productHandle, ts }).
     Set when the user submits, looked up when rendering cards so we can
     show an Edit button on their own reviews. */
  const MY_REVIEWS_KEY = 'vlMyReviews';
  function getMyReviews() {
    try { return JSON.parse(localStorage.getItem(MY_REVIEWS_KEY) || '{}'); }
    catch (e) { return {}; }
  }
  function saveMyReview(id, token, productHandle) {
    if (!id || !token) return;
    const map = getMyReviews();
    map[id] = { token: token, productHandle: productHandle || '', ts: Date.now() };
    try { localStorage.setItem(MY_REVIEWS_KEY, JSON.stringify(map)); } catch (e) {}
  }
  function getMyReview(id) {
    const map = getMyReviews();
    return map[id] || null;
  }

  /* ---------- Lightbox ---------- */
  let lightboxEl = null;
  function ensureLightbox() {
    if (lightboxEl) return lightboxEl;
    lightboxEl = document.createElement('div');
    lightboxEl.className = 'vl-review-lightbox';
    lightboxEl.innerHTML = '<div class="vl-review-lightbox__inner"><button type="button" class="vl-review-lightbox__close" aria-label="Close">✕</button><div class="vl-review-lightbox__media"></div></div>';
    document.body.appendChild(lightboxEl);
    lightboxEl.addEventListener('click', function (e) {
      if (e.target === lightboxEl || e.target.classList.contains('vl-review-lightbox__close')) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightboxEl.classList.contains('is-open')) closeLightbox();
    });
    return lightboxEl;
  }
  function openImage(src) {
    const lb = ensureLightbox();
    const mediaWrap = $('.vl-review-lightbox__media', lb);
    mediaWrap.innerHTML = '';
    const img = document.createElement('img');
    img.src = src;
    img.alt = '';
    mediaWrap.appendChild(img);
    lb.classList.add('is-open');
  }
  function openVideo(src) {
    const lb = ensureLightbox();
    const mediaWrap = $('.vl-review-lightbox__media', lb);
    mediaWrap.innerHTML = '';
    const video = document.createElement('video');
    video.src = src;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    mediaWrap.appendChild(video);
    lb.classList.add('is-open');
  }
  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxEl.classList.remove('is-open');
    const mediaWrap = $('.vl-review-lightbox__media', lightboxEl);
    if (mediaWrap) mediaWrap.innerHTML = '';
  }

  /* ---------- Pagination renderer ---------- */
  function buildPaginationButtons(totalPages, currentPage) {
    // Returns array of items: { type: 'page'|'ellipsis'|'prev'|'next', page?: number, disabled?: boolean, current?: boolean }
    const items = [];
    items.push({ type: 'prev', disabled: currentPage <= 1 });

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        items.push({ type: 'page', page: i, current: i === currentPage });
      }
    } else {
      const pages = new Set([1, 2, totalPages - 1, totalPages, currentPage - 1, currentPage, currentPage + 1]);
      const sorted = Array.from(pages).filter(p => p >= 1 && p <= totalPages).sort((a, b) => a - b);
      let last = 0;
      for (const p of sorted) {
        if (last && p - last > 1) items.push({ type: 'ellipsis' });
        items.push({ type: 'page', page: p, current: p === currentPage });
        last = p;
      }
    }
    items.push({ type: 'next', disabled: currentPage >= totalPages });
    return items;
  }

  function renderPagination(navEl, totalPages, currentPage, onPageClick) {
    navEl.innerHTML = '';
    if (totalPages <= 1) {
      navEl.hidden = true;
      return;
    }
    navEl.hidden = false;
    const items = buildPaginationButtons(totalPages, currentPage);
    items.forEach(item => {
      if (item.type === 'ellipsis') {
        const span = document.createElement('span');
        span.className = 'vl-reviews__page-ellipsis';
        span.textContent = '…';
        navEl.appendChild(span);
        return;
      }
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vl-reviews__page-btn' + (item.current ? ' is-current' : '');
      btn.disabled = !!item.disabled || !!item.current;
      if (item.type === 'page') {
        btn.textContent = String(item.page);
        btn.setAttribute('aria-label', 'Page ' + item.page);
        if (item.current) btn.setAttribute('aria-current', 'page');
        btn.addEventListener('click', () => onPageClick(item.page));
      } else if (item.type === 'prev') {
        btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';
        btn.setAttribute('aria-label', 'Previous page');
        btn.addEventListener('click', () => { if (!btn.disabled) onPageClick(currentPage - 1); });
      } else if (item.type === 'next') {
        btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';
        btn.setAttribute('aria-label', 'Next page');
        btn.addEventListener('click', () => { if (!btn.disabled) onPageClick(currentPage + 1); });
      }
      navEl.appendChild(btn);
    });
  }

  /* ---------- Init each section ---------- */
  function initSection(sectionEl) {
    if (sectionEl.dataset.vlInit) return;
    sectionEl.dataset.vlInit = '1';

    let workerUrl = (sectionEl.dataset.workerUrl || '').trim().replace(/\/+$/, '');
    if (workerUrl && !/^https?:\/\//i.test(workerUrl)) {
      workerUrl = 'https://' + workerUrl;
    }
    const perPage = Math.max(1, parseInt(sectionEl.dataset.perPage, 10) || 5);

    const listEl = $('[data-review-list]', sectionEl);
    const cards = $$('.vl-review', listEl);
    const paginationEl = $('[data-pagination]', sectionEl);
    const sortSel = $('[data-sort]', sectionEl);
    const filterStarBtns = $$('[data-filter-star]', sectionEl);
    const filterClearBtn = $('[data-filter-clear]', sectionEl);

    let currentPage = 1;
    let activeFilter = 0;
    let activeSort = 'newest';

    function applyView() {
      const matched = cards.filter(c => {
        const r = parseInt(c.dataset.rating, 10) || 0;
        return activeFilter === 0 ? true : r === activeFilter;
      });

      matched.sort((a, b) => {
        switch (activeSort) {
          case 'oldest':  return (parseInt(a.dataset.date, 10) || 0) - (parseInt(b.dataset.date, 10) || 0);
          case 'highest': return (parseInt(b.dataset.rating, 10) || 0) - (parseInt(a.dataset.rating, 10) || 0);
          case 'lowest':  return (parseInt(a.dataset.rating, 10) || 0) - (parseInt(b.dataset.rating, 10) || 0);
          case 'helpful': return (parseInt(b.dataset.helpful, 10) || 0) - (parseInt(a.dataset.helpful, 10) || 0);
          case 'newest':
          default:        return (parseInt(b.dataset.date, 10) || 0) - (parseInt(a.dataset.date, 10) || 0);
        }
      });

      const totalPages = Math.max(1, Math.ceil(matched.length / perPage));
      if (currentPage > totalPages) currentPage = totalPages;
      if (currentPage < 1) currentPage = 1;

      const startIdx = (currentPage - 1) * perPage;
      const endIdx = startIdx + perPage;

      cards.forEach(c => c.classList.add('is-hidden'));

      const frag = document.createDocumentFragment();
      matched.forEach((c, idx) => {
        if (idx >= startIdx && idx < endIdx) c.classList.remove('is-hidden');
        frag.appendChild(c);
      });
      cards.forEach(c => { if (matched.indexOf(c) === -1) frag.appendChild(c); });
      listEl.appendChild(frag);

      if (paginationEl) {
        renderPagination(paginationEl, totalPages, currentPage, (newPage) => {
          currentPage = newPage;
          applyView();
          // smooth scroll to top of list
          const top = listEl.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top, behavior: 'smooth' });
        });
      }
    }

    filterStarBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const n = parseInt(btn.dataset.filterStar, 10);
        activeFilter = (activeFilter === n) ? 0 : n;
        filterStarBtns.forEach(b => {
          const v = parseInt(b.dataset.filterStar, 10);
          b.classList.toggle('is-active', activeFilter !== 0 && v <= activeFilter);
        });
        if (filterClearBtn) filterClearBtn.hidden = activeFilter === 0;
        currentPage = 1;
        applyView();
      });
    });
    if (filterClearBtn) {
      filterClearBtn.addEventListener('click', () => {
        activeFilter = 0;
        filterStarBtns.forEach(b => b.classList.remove('is-active'));
        filterClearBtn.hidden = true;
        currentPage = 1;
        applyView();
      });
    }

    if (sortSel) {
      sortSel.addEventListener('change', () => {
        activeSort = sortSel.value;
        currentPage = 1;
        applyView();
      });
    }

    /* Votes — like and dislike are mutually exclusive. Click switches; click same = remove. */
    const votedMap = getVotedMap();
    // Group buttons by review so we can manipulate the pair together.
    const reviewVoteEls = {};
    $$('.vl-review__vote', sectionEl).forEach(btn => {
      const reviewId = btn.dataset.review;
      const dir = btn.dataset.vote;
      reviewVoteEls[reviewId] = reviewVoteEls[reviewId] || {};
      reviewVoteEls[reviewId][dir] = btn;
    });

    Object.keys(reviewVoteEls).forEach(reviewId => {
      const pair = reviewVoteEls[reviewId];
      const upBtn = pair.up;
      const downBtn = pair.down;
      const initialState = getVoteState(votedMap, reviewId);
      if (initialState === 'up' && upBtn) upBtn.classList.add('is-voted');
      if (initialState === 'down' && downBtn) downBtn.classList.add('is-voted');

      function bind(btn, dir) {
        if (!btn) return;
        btn.addEventListener('click', () => {
          if (!workerUrl) { alert('Voting is not enabled (Worker URL missing).'); return; }
          const currentState = getVoteState(getVotedMap(), reviewId);
          let helpfulDelta = 0, unhelpfulDelta = 0, newState;
          if (currentState === dir) {
            // Toggle off: remove the vote
            if (dir === 'up') helpfulDelta = -1; else unhelpfulDelta = -1;
            newState = null;
          } else if (currentState) {
            // Switch: remove old direction, add new
            if (currentState === 'up') helpfulDelta = -1; else unhelpfulDelta = -1;
            if (dir === 'up') helpfulDelta += 1; else unhelpfulDelta += 1;
            newState = dir;
          } else {
            // Fresh vote
            if (dir === 'up') helpfulDelta = 1; else unhelpfulDelta = 1;
            newState = dir;
          }
          if (upBtn) upBtn.disabled = true;
          if (downBtn) downBtn.disabled = true;

          fetch(workerUrl + '/vote', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ reviewId: reviewId, helpful_delta: helpfulDelta, unhelpful_delta: unhelpfulDelta })
          })
          .then(r => r.text().then(raw => {
            try { return JSON.parse(raw); }
            catch (_) { return { ok: false, error: 'Worker returned unexpected response.' }; }
          }))
          .then(data => {
            if (upBtn) upBtn.disabled = false;
            if (downBtn) downBtn.disabled = false;
            if (!data || !data.ok) {
              alert((data && data.error) || 'Could not record your vote.');
              return;
            }
            // Update counts from server response (authoritative).
            if (upBtn) {
              const upCount = $('[data-helpful-count]', upBtn);
              if (upCount) upCount.textContent = String(data.helpful || 0);
            }
            if (downBtn) {
              const downCount = $('[data-unhelpful-count]', downBtn);
              if (downCount) downCount.textContent = String(data.unhelpful || 0);
            }
            // Update visual state.
            if (upBtn) upBtn.classList.toggle('is-voted', newState === 'up');
            if (downBtn) downBtn.classList.toggle('is-voted', newState === 'down');
            // Persist.
            setVoteState(reviewId, newState);
            votedMap[reviewId] = newState;
            // Keep sort attribute current.
            const card = btn.closest('.vl-review');
            if (card && typeof data.helpful === 'number') card.dataset.helpful = data.helpful;
          })
          .catch(() => {
            if (upBtn) upBtn.disabled = false;
            if (downBtn) downBtn.disabled = false;
            alert('Network error — could not record your vote.');
          });
        });
      }
      bind(upBtn, 'up');
      bind(downBtn, 'down');
    });

    /* Edit-own-review buttons — show on cards whose ID is in localStorage. */
    injectEditButtons(sectionEl);

    /* Media lightbox */
    $$('.vl-review__media-item', sectionEl).forEach(el => {
      el.addEventListener('click', (e) => {
        if (el.dataset.mediaType === 'video') {
          e.preventDefault();
          openVideo(el.dataset.src);
        } else if (el.tagName === 'A') {
          e.preventDefault();
          openImage(el.getAttribute('href'));
        }
      });
    });

    /* Modal form */
    const modal = $('[data-review-modal]', sectionEl);
    const openBtns = $$('[data-review-open]', sectionEl);
    if (modal) {
      openBtns.forEach(b => {
        b.addEventListener('click', () => {
          setFormMode(modal, 'create', null);
          if (typeof modal.showModal === 'function') modal.showModal();
          else modal.setAttribute('open', '');
        });
      });
      const closeBtn = $('[data-review-close]', modal);
      if (closeBtn) closeBtn.addEventListener('click', () => modal.close());
      modal.addEventListener('click', (e) => {
        const rect = modal.getBoundingClientRect();
        if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
          modal.close();
        }
      });
      initForm(modal, workerUrl, sectionEl);
    }

    applyView();
  }

  /* ---------- Product picker ---------- */
  function initProductPicker(sectionEl, form) {
    const picker = $('[data-product-picker]', sectionEl);
    const trigger = $('[data-product-trigger]', form);
    const displayEl = $('[data-product-display]', form);
    const hiddenInput = $('[data-product-handle-input]', form);
    const clearBtn = $('[data-product-clear]', form);
    if (!picker || !trigger) return; // form is locked to a product

    const closeBtn = $('[data-product-picker-close]', picker);
    const searchInput = $('[data-product-search]', picker);
    const grid = $('[data-product-grid]', picker);
    const emptyEl = $('[data-product-empty]', picker);
    const cards = $$('.vl-product-picker__card', picker);

    function open() {
      if (typeof picker.showModal === 'function') picker.showModal();
      else picker.setAttribute('open', '');
      setTimeout(() => searchInput && searchInput.focus(), 60);
    }
    function close() {
      if (typeof picker.close === 'function') picker.close();
      else picker.removeAttribute('open');
    }

    trigger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    picker.addEventListener('click', (e) => {
      const rect = picker.getBoundingClientRect();
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
        close();
      }
    });

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        const q = searchInput.value.trim().toLowerCase();
        let visibleCount = 0;
        cards.forEach(card => {
          const title = (card.dataset.productTitle || '').toLowerCase();
          const match = !q || title.indexOf(q) !== -1;
          card.classList.toggle('is-hidden', !match);
          if (match) visibleCount++;
        });
        if (emptyEl) emptyEl.hidden = visibleCount > 0;
      });
    }

    cards.forEach(card => {
      card.addEventListener('click', () => {
        const handle = card.dataset.productHandle;
        const title = card.dataset.productTitle;
        const image = card.dataset.productImage;
        if (hiddenInput) hiddenInput.value = handle || '';
        if (displayEl) {
          displayEl.innerHTML = '';
          if (image) {
            const img = document.createElement('img');
            img.src = image;
            img.alt = '';
            displayEl.appendChild(img);
          }
          const span = document.createElement('span');
          span.textContent = title || handle;
          displayEl.appendChild(span);
        }
        if (clearBtn) clearBtn.hidden = false;
        close();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        if (hiddenInput) hiddenInput.value = '';
        if (displayEl) {
          displayEl.innerHTML = '<span class="vl-review-form__product-trigger-placeholder">Click to choose a product</span>';
        }
        clearBtn.hidden = true;
      });
    }
  }

  /* ---------- Form (inside the review modal) ---------- */
  function initForm(modal, workerUrl, sectionEl) {
    const form = $('[data-review-form]', modal);
    if (!form) return;

    initProductPicker(sectionEl, form);

    /* Star input */
    const starBtns = $$('.vl-review-form__star', form);
    const ratingInput = $('[data-rating-value]', form);
    function setRating(n) {
      ratingInput.value = String(n);
      starBtns.forEach(b => {
        const v = parseInt(b.dataset.star, 10);
        b.classList.toggle('is-on', v <= n);
      });
    }
    starBtns.forEach(b => {
      b.addEventListener('click', () => setRating(parseInt(b.dataset.star, 10)));
      b.addEventListener('mouseenter', () => {
        const v = parseInt(b.dataset.star, 10);
        starBtns.forEach(sb => {
          const sv = parseInt(sb.dataset.star, 10);
          sb.classList.toggle('is-on', sv <= v);
        });
      });
    });
    const starsWrap = form.querySelector('.vl-review-form__stars');
    if (starsWrap) {
      starsWrap.addEventListener('mouseleave', () => {
        const current = parseInt(ratingInput.value, 10) || 0;
        setRating(current);
      });
    }

    /* Custom file upload */
    const filesInput = $('[data-review-files]', form);
    const fileList = $('[data-review-file-list]', form);
    const uploadLabel = $('[data-review-upload]', form);

    function renderFileChips() {
      fileList.innerHTML = '';
      const files = Array.from(filesInput.files || []);
      files.forEach((f, idx) => {
        const chip = document.createElement('span');
        chip.className = 'vl-review-form__file-chip';
        const name = document.createElement('span');
        name.textContent = f.name + ' · ' + (f.size / 1024 / 1024).toFixed(1) + ' MB';
        chip.appendChild(name);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'vl-review-form__file-chip-remove';
        remove.setAttribute('aria-label', 'Remove ' + f.name);
        remove.textContent = '×';
        remove.addEventListener('click', () => {
          const dt = new DataTransfer();
          Array.from(filesInput.files).forEach((file, i) => {
            if (i !== idx) dt.items.add(file);
          });
          filesInput.files = dt.files;
          renderFileChips();
        });
        chip.appendChild(remove);
        fileList.appendChild(chip);
      });
    }

    function validateFiles() {
      const files = Array.from(filesInput.files || []);
      if (files.length > MAX_FILES) {
        alert('Please upload up to ' + MAX_FILES + ' files.');
        filesInput.value = '';
        fileList.innerHTML = '';
        return false;
      }
      for (const f of files) {
        if (f.size > MAX_FILE_MB * 1024 * 1024) {
          alert('File "' + f.name + '" is larger than ' + MAX_FILE_MB + ' MB.');
          filesInput.value = '';
          fileList.innerHTML = '';
          return false;
        }
      }
      return true;
    }

    if (filesInput) {
      filesInput.addEventListener('change', () => {
        if (validateFiles()) renderFileChips();
      });
    }

    /* Drag and drop support on the upload label */
    if (uploadLabel && filesInput) {
      ['dragenter', 'dragover'].forEach(evt => {
        uploadLabel.addEventListener(evt, (e) => {
          e.preventDefault();
          uploadLabel.classList.add('is-dragging');
        });
      });
      ['dragleave', 'dragend', 'drop'].forEach(evt => {
        uploadLabel.addEventListener(evt, (e) => {
          uploadLabel.classList.remove('is-dragging');
        });
      });
      uploadLabel.addEventListener('drop', (e) => {
        e.preventDefault();
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
          const dt = new DataTransfer();
          Array.from(e.dataTransfer.files).forEach(f => dt.items.add(f));
          filesInput.files = dt.files;
          if (validateFiles()) renderFileChips();
        }
      });
    }

    /* Submit */
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = $('[data-review-submit]', form);
      const feedback = $('[data-review-feedback]', form);
      feedback.className = 'vl-review-form__feedback';
      feedback.textContent = '';

      if (!workerUrl) {
        feedback.className = 'vl-review-form__feedback is-error';
        feedback.textContent = 'Submission endpoint is not configured. Contact the store.';
        return;
      }

      if (!ratingInput.value) {
        feedback.className = 'vl-review-form__feedback is-error';
        feedback.textContent = 'Please select a rating.';
        return;
      }

      if (form.querySelector('input[name="company"]').value) {
        feedback.className = 'vl-review-form__feedback is-success';
        feedback.textContent = 'Thanks for your review.';
        form.reset();
        return;
      }

      const mode = form.dataset.mode === 'edit' ? 'edit' : 'create';
      const submitLabelDefault = mode === 'edit' ? 'Save changes' : 'Submit review';

      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');
      $('.vl-review-form__submit-label', submitBtn).textContent = mode === 'edit' ? 'Saving…' : 'Submitting…';

      const fd = new FormData();
      fd.append('rating', ratingInput.value);
      fd.append('name', form.querySelector('[name="name"]').value);
      const titleEl = form.querySelector('[name="title"]');
      if (titleEl) fd.append('title', titleEl.value);
      fd.append('body', form.querySelector('[name="body"]').value);

      const files = Array.from((filesInput && filesInput.files) || []);
      files.forEach(f => fd.append('files', f, f.name));

      let endpoint;
      let productHandleForSave = '';
      if (mode === 'edit') {
        const reviewIdEl = form.querySelector('[data-review-id-input]');
        const editTokenEl = form.querySelector('[data-edit-token-input]');
        const reviewId = (reviewIdEl && reviewIdEl.value) || '';
        const editToken = (editTokenEl && editTokenEl.value) || '';
        if (!reviewId || !editToken) {
          feedback.className = 'vl-review-form__feedback is-error';
          feedback.textContent = 'Missing review identifier. Please refresh and try again.';
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');
          $('.vl-review-form__submit-label', submitBtn).textContent = submitLabelDefault;
          return;
        }
        fd.append('review_id', reviewId);
        fd.append('edit_token', editToken);
        endpoint = '/edit';
        const existing = getMyReview(reviewId);
        productHandleForSave = (existing && existing.productHandle) || '';
      } else {
        fd.append('email', form.querySelector('[name="email"]').value);
        const handleEl = form.querySelector('[data-product-handle-input]');
        productHandleForSave = (handleEl && handleEl.value) || form.dataset.productHandle || '';
        const productId = form.dataset.productId || '';
        if (productHandleForSave) fd.append('product_handle', productHandleForSave);
        if (productId) fd.append('product_id', productId);
        endpoint = '/submit';
      }

      try {
        const res = await fetch(workerUrl + endpoint, { method: 'POST', body: fd });
        const raw = await res.text();
        let data;
        try { data = JSON.parse(raw); }
        catch (_) {
          throw new Error('Server returned unexpected response. Check that the Cloudflare Worker URL is set correctly in the theme editor. (Response: ' + raw.slice(0, 80) + ')');
        }
        if (!res.ok || !data.ok) throw new Error((data && data.error) || (mode === 'edit' ? 'Update failed.' : 'Submission failed.'));

        // Remember ownership so the Edit button appears on the next page load.
        if (mode === 'create' && data.id && data.editToken) {
          saveMyReview(data.id, data.editToken, productHandleForSave);
        }

        feedback.className = 'vl-review-form__feedback is-success';
        feedback.textContent = mode === 'edit'
          ? 'Your review was updated.'
          : 'Thank you! Your review was submitted and will appear shortly.';
        form.reset();
        starBtns.forEach(b => b.classList.remove('is-on'));
        if (fileList) fileList.innerHTML = '';
        setTimeout(() => {
          if (typeof modal.close === 'function') modal.close();
          // Cache-bust query param forces Shopify edge to skip cache so the change shows.
          const sep = window.location.search ? '&' : '?';
          window.location.href = window.location.pathname + window.location.search + sep + '_r=' + Date.now();
        }, 1200);
      } catch (err) {
        feedback.className = 'vl-review-form__feedback is-error';
        feedback.textContent = err.message || (mode === 'edit' ? 'Update failed. Please try again.' : 'Submission failed. Please try again.');
      } finally {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
        $('.vl-review-form__submit-label', submitBtn).textContent = submitLabelDefault;
      }
    });
  }

  /* ---------- Edit-mode form helpers ---------- */

  function setFormMode(modal, mode, prefill) {
    const form = $('[data-review-form]', modal);
    if (!form) return;
    form.dataset.mode = mode;

    const titleEl = $('[data-modal-title]', modal);
    const introEl = $('[data-modal-intro]', modal);
    const submitLabel = $('.vl-review-form__submit-label', form);
    const emailRow = $('[data-email-row]', form);
    const emailInput = form.querySelector('[name="email"]');
    const reviewIdInput = form.querySelector('[data-review-id-input]');
    const editTokenInput = form.querySelector('[data-edit-token-input]');
    const nameInput = form.querySelector('[name="name"]');
    const titleInput = form.querySelector('[name="title"]');
    const bodyInput = form.querySelector('[name="body"]');
    const ratingInput = form.querySelector('[data-rating-value]');
    const starBtns = $$('.vl-review-form__star', form);
    const fileList = $('[data-review-file-list]', form);
    const filesInput = $('[data-review-files]', form);
    const feedback = $('[data-review-feedback]', form);

    // Clear feedback + files state for both modes.
    if (feedback) { feedback.className = 'vl-review-form__feedback'; feedback.textContent = ''; }
    if (filesInput) filesInput.value = '';
    if (fileList) fileList.innerHTML = '';

    if (mode === 'edit' && prefill) {
      if (titleEl) titleEl.textContent = titleEl.dataset.titleEdit || 'Edit your review';
      if (introEl) introEl.textContent = introEl.dataset.introEdit || '';
      if (submitLabel) submitLabel.textContent = 'Save changes';
      if (emailRow) emailRow.hidden = true;
      if (emailInput) emailInput.required = false;

      if (reviewIdInput) reviewIdInput.value = prefill.reviewId || '';
      if (editTokenInput) editTokenInput.value = prefill.editToken || '';
      if (nameInput) nameInput.value = prefill.name || '';
      if (titleInput) titleInput.value = prefill.title || '';
      if (bodyInput) bodyInput.value = prefill.body || '';
      const r = parseInt(prefill.rating, 10) || 0;
      if (ratingInput) ratingInput.value = r ? String(r) : '';
      starBtns.forEach(b => {
        const v = parseInt(b.dataset.star, 10);
        b.classList.toggle('is-on', !!r && v <= r);
      });
    } else {
      if (titleEl) titleEl.textContent = titleEl.dataset.titleCreate || 'Leave a review';
      if (introEl) introEl.textContent = introEl.dataset.introCreate || '';
      if (submitLabel) submitLabel.textContent = 'Submit review';
      if (emailRow) emailRow.hidden = false;
      if (emailInput) emailInput.required = true;
      if (reviewIdInput) reviewIdInput.value = '';
      if (editTokenInput) editTokenInput.value = '';
      form.reset();
      starBtns.forEach(b => b.classList.remove('is-on'));
    }
  }

  function injectEditButtons(sectionEl) {
    const modal = $('[data-review-modal]', sectionEl);
    if (!modal) return;
    const my = getMyReviews();
    if (!Object.keys(my).length) return;

    $$('.vl-review', sectionEl).forEach(card => {
      const id = card.dataset.reviewId;
      if (!id || !my[id]) return;
      if (card.querySelector('.vl-review__edit-btn')) return; // already injected

      const footer = card.querySelector('.vl-review__foot') || card;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vl-review__edit-btn';
      btn.setAttribute('aria-label', 'Edit your review');
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg><span>Edit</span>';
      btn.addEventListener('click', () => {
        const ratingAttr = parseInt(card.dataset.rating, 10) || 0;
        const nameEl = card.querySelector('.vl-review__name');
        const titleEl = card.querySelector('.vl-review__title');
        const bodyEl = card.querySelector('.vl-review__body');
        setFormMode(modal, 'edit', {
          reviewId: id,
          editToken: my[id].token,
          rating: ratingAttr,
          name: nameEl ? nameEl.textContent.trim() : '',
          title: titleEl ? titleEl.textContent.trim() : '',
          body: bodyEl ? bodyEl.textContent.trim() : ''
        });
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
      });
      footer.appendChild(btn);
    });
  }

  function boot() {
    $$('[data-vl-reviews]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
